import { getAppChatApi, getChatApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { ChatDialogResponse } from '@/core/generated/api';

const pendingReads = new Map<string, Promise<void>>();

/** Согласует автоматическое прочтение и ручную отметку переписки */
export const chatReadStateService = {
    /** Подтверждает показанное сообщение и отслеживает незавершённое прочтение */
    async confirm(native: boolean, dialogId: string, throughMessageId: string): Promise<void> {
        const request = {
            dialogId,
            markChatDialogReadRequest: { throughMessageId },
        };

        const confirmation = (async (): Promise<void> => {
            if (native) {
                await getAppChatApi().markAppChatRead(request);
            } else {
                await getChatApi().markChatDialogRead(request);
            }
        })();

        pendingReads.set(dialogId, confirmation);

        try {
            await confirmation;
        } catch (error: unknown) {
            rethrowHandledApiError(error);
        } finally {
            if (pendingReads.get(dialogId) === confirmation) pendingReads.delete(dialogId);
        }
    },

    /** Изменяет чтение всего диалога после уже начатого подтверждения */
    async setReadState(dialog: ChatDialogResponse, unread: boolean): Promise<void> {
        if (!dialog.id) return;

        await Promise.allSettled([pendingReads.get(dialog.id)]);

        try {
            const request = { dialogId: dialog.id };

            if (dialog.channel?.id === 'vox') {
                if (unread) await getAppChatApi().markAppChatUnread(request);
                else await getAppChatApi().markAppChatReadAll(request);
            } else {
                if (unread) await getChatApi().markChatDialogUnread(request);
                else await getChatApi().markChatDialogReadAll(request);
            }
        } catch (error: unknown) {
            rethrowHandledApiError(error);
        }
    },
};
